import { apiSlice } from './apiSlice';
import { VehicleTypeCostFee } from '../../@types/vehicleCostFee';

export const vehicleTypeCostFeeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleTypeCostFeesByTourBundle: builder.query<VehicleTypeCostFee[], string>({
      query: (tourBundleId) => `/vehicle-type-cost-fees/by-tour-bundle/${tourBundleId}`,
      providesTags: ['VehicleTypeCostFee'],
    }),
    getVehicleTypeCostFeeById: builder.query<VehicleTypeCostFee, number>({
      query: (id) => `/vehicle-type-cost-fees/${id}`,
      providesTags: ['VehicleTypeCostFee'],
    }),
    createVehicleTypeCostFee: builder.mutation<
      VehicleTypeCostFee,
      Omit<VehicleTypeCostFee, 'id' | 'vehicleTypeName' | 'createdAt' | 'updatedAt'>
    >({
      query: (data) => ({
        url: `/vehicle-type-cost-fees`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['VehicleTypeCostFee'],
    }),
    createMultipleVehicleTypeCostFees: builder.mutation<
      VehicleTypeCostFee[],
      Omit<VehicleTypeCostFee, 'id' | 'vehicleTypeName' | 'createdAt' | 'updatedAt'>[]
    >({
      query: (data) => ({
        url: `/vehicle-type-cost-fees/bulk`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['VehicleTypeCostFee'],
    }),
    updateVehicleTypeCostFee: builder.mutation<
      VehicleTypeCostFee,
      { id: number; data: Partial<VehicleTypeCostFee> }
    >({
      query: ({ id, data }) => ({
        url: `/vehicle-type-cost-fees/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['VehicleTypeCostFee'],
    }),
    deleteVehicleTypeCostFee: builder.mutation<void, number>({
      query: (id) => ({
        url: `/vehicle-type-cost-fees/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['VehicleTypeCostFee'],
    }),
    deleteMultipleVehicleTypeCostFees: builder.mutation<void, number[]>({
      query: (ids) => ({
        url: `/vehicle-type-cost-fees/bulk`,
        method: 'DELETE',
        body: { ids },
      }),
      invalidatesTags: ['VehicleTypeCostFee'],
    }),
  }),
});

export const {
  useGetVehicleTypeCostFeesByTourBundleQuery,
  useGetVehicleTypeCostFeeByIdQuery,
  useCreateVehicleTypeCostFeeMutation,
  useCreateMultipleVehicleTypeCostFeesMutation,
  useUpdateVehicleTypeCostFeeMutation,
  useDeleteVehicleTypeCostFeeMutation,
  useDeleteMultipleVehicleTypeCostFeesMutation,
} = vehicleTypeCostFeeApiSlice;
